<template>
  <div>
    <v-card class="ma-2 white rounded-lg">
      <v-card-title class="secondary--text">لیست کسب و کار ها</v-card-title>

      <v-card-text>
        <div>
          <m-datatable
            :show-select="false"
            :show-filter-row="false"
            :headers="headers"
            :apiUrl="url"
            :filters.sync="filters"
            @dblclick:row="(e, row) => handleRowClick(row.item)"
            ref="datatable"
          >
            <template #item.detail="{ item }">
              <v-tooltip bottom color="info">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" color="white" icon :to="to(item)">
                    <v-img max-width="20" max-height="20" src="/img/icons/info_circle.svg"></v-img>
                  </v-btn>
                </template>
                مشاهده سابقه تراکنش
              </v-tooltip>
            </template>
            <template #item.users="{ item }">
              <div v-for="user in item.users" :key="user">
                {{ user }}
              </div>
            </template>
            
            <template #item.edit="{ item }">
              <edit-company :item="item" @updated="$refs.datatable.getDataFromApi()" />
            </template>
            
          </m-datatable>
        </div>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" :overlay="true" transition="dialog-transition">
      <companie-detail v-if="companieId" :id="companieId" />
    </v-dialog>
  </div>
</template>

<script>
import CompanieDetail from "@/components/companies/CompanieDetail.vue";
import EditCompany from '@/components/companies/EditCompany.vue';
export default {
  name: "CompaniesList",
  props: {},
  components: { CompanieDetail, EditCompany },
  data() {
    return {
      filters: {},
      dialog: false,
      companieId: null,
      url: "sobhanAdmin/companies/",
    };
  },
  computed: {
    headers() {
      let headers = [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "نام",
          value: "name",
        },
        {
          text: "مدیر کسب و کار",
          value: "created_by",
        },
        {
          text: "بسته فعلی",
          value: "current_package.name_display",
        },
        {
          text: "تعداد روز باقی مانده",
          value: "current_package.remaining_days",
        },
        {
          text: "آزمایشی",
          value: "current_package.is_trial",
          type: 'boolean'
        },
        {
          text: "حسابداری ابری",
          value: "needs_accountant",
          type: 'boolean'
        },
        {
          text: "سابقه تراکنش ها",
          value: "detail",
          sortable: false,
          filterable: false,
        },
        {
          text: "ویرایش",
          value: "edit",
          sortable: false,
          filterable: false,
        },
      ];

      return headers;
    },
  },
  methods: {
    to(item) {
      return {
        name: "FactorsList",
        params: {
          id: item.id,
        },
      };
    },
    handleRowClick(row) {
      this.companieId = row.id;
      this.dialog = true;
    },
  },
};
</script>

<style scoped lang="scss"></style>
